import styles from "./alert-modal.module.css";
import { Modal } from "BEDROCK/shared-components/modal";
import { CTAButton } from "./cta-button";

interface AlertModalProps {
  title: string;
  message: string;
  isShowing: boolean;
  proceedCTA?: string;
  dismissCTA?: string;
  onProceed?: () => void;
  onDismiss: () => void;
}

export const AlertModal = ({
  title,
  message,
  isShowing,
  proceedCTA,
  dismissCTA = "OK",
  onProceed,
  onDismiss,
}: AlertModalProps) => {
  return (
    <Modal isOpen={isShowing} showCloseButton={false} onClose={onDismiss}>
      <div className={styles.container}>
        <h2>{title}</h2>
        <p>{message}</p>
        <div className={styles.ctas}>
          <CTAButton variant="SECONDARY" onClick={onDismiss}>
            {dismissCTA ?? "OK"}
          </CTAButton>
          {onProceed && (
            <CTAButton variant="PRIMARY" onClick={onProceed}>
              {proceedCTA ?? "PROCEED"}
            </CTAButton>
          )}
        </div>
      </div>
    </Modal>
  );
};
